import { cn } from '@/lib/utils'

/** Unread messages from one person: a primary-color bubble on the right of the row (99+ cap). */
export const UnreadCount = ({ count, className }: { count: number; className?: string }) =>
  count > 0 ? (
    <span
      data-chat-unread={count}
      className={cn('inline-flex h-5 min-w-[1.25rem] shrink-0 items-center justify-center rounded-full bg-primary-600 px-1.5 text-[11px] font-semibold text-primary-foreground', className)}
    >
      {count > 99 ? '99+' : count}
    </span>
  ) : null
